import { render, staticRenderFns } from "./TypeOfHeatPumpFormStep.vue?vue&type=template&id=37080c3a"
import script from "./TypeOfHeatPumpFormStep.vue?vue&type=script&lang=js"
export * from "./TypeOfHeatPumpFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports